import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useHistory} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';
import {parse} from 'query-string';

import * as snackbarsActions from '../../../actions/snackbars';
import {notificationType} from '../../../utils/constant';
import ReceivedInvitationsView from '../../notification/ReceivedInvitationsView';
import relationshipService from '../../../services/relationship/RelationshipService';
import InvitationRejectionReason from '../../InvitationRejectionReason';
import {useClientsStore} from '../ClientsStore';

function ReceivedInvitationsContainer() {
  const organisation = useSelector(state => state.organisation);
  const invitations = useSelector(state => state.notifications.notificationsWithActions
    .filter(notification => notification.type === notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED));
  const globalDispatch = useDispatch();
  const {dispatch} = useClientsStore();
  const location = useLocation();
  const history = useHistory();

  const [currentInvitation, setCurrentInvitation] = React.useState({});
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleOpenRejectionReasonModal = invitation => {
    setIsModalOpen(true);
    setCurrentInvitation(invitation);
  };

  const handleAcceptInvitation = invitation => (
    relationshipService.accept(invitation.relationship.relationshipId)
      .then(() => {
        globalDispatch(snackbarsActions.addSuccess(<Translate value="client.relationshipAccepted"/>));
        dispatch({type: 'FETCH_DATA'});
      }).catch(() => {
        globalDispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      })
  );

  const handleCloseRejectionReasonModal = () => {
    setIsModalOpen(false);
    setCurrentInvitation({});
  };

  const handleRejectSuccess = () => {
    globalDispatch(snackbarsActions.addSuccess(<Translate value="client.relationshipRejected"/>));
    dispatch({type: 'FETCH_DATA'});
    if (currentInvitation.isFromQuery) {
      history.push('/clients/list');
    }
  };

  const handleRejectError = () => {
    if (currentInvitation.isFromQuery) {
      globalDispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
    }
  };

  const handleInvitationFromUrl = () => {
    const relationshipIdToAccept = parse(location.search).acceptedRelationshipId;
    const relationshipIdToReject = parse(location.search).rejectedRelationshipId;

    if ((relationshipIdToAccept || relationshipIdToReject) && !organisation.depositor) {
      history.push('/clients/list');
      globalDispatch(snackbarsActions.addError(<Translate value="relationship.errorDepositorService"/>));
      return;
    }

    if (relationshipIdToAccept) {
      const invitation = {relationship: {relationshipId: relationshipIdToAccept}};
      handleAcceptInvitation(invitation)
        .then(() => {
          history.push('/clients/list');
        });
    } else if (relationshipIdToReject) {
      const invitation = {relationship: {relationshipId: relationshipIdToReject}, isFromQuery: true};
      handleOpenRejectionReasonModal(invitation);
    }
  };

  React.useEffect(handleInvitationFromUrl, []);

  return (
    <>
      <ReceivedInvitationsView
        invitations={invitations}
        onOpenRejectionReasonModal={handleOpenRejectionReasonModal}
        onAcceptInvitation={handleAcceptInvitation}
      />
      {isModalOpen &&
        <InvitationRejectionReason
          onClose={handleCloseRejectionReasonModal}
          invitation={currentInvitation}
          onSubmitSuccess={handleRejectSuccess}
          onSubmitError={handleRejectError}
        />
      }
    </>
  );
}

export default ReceivedInvitationsContainer;
